export const AuthObservabilityEvents = {
  LOGIN_SUCCEEDED: 'login_succeeded',
  LOGIN_FAILED: 'login_failed',
  BIOMETRIC_UNLINKED: 'biometric_unlinked',
  BIOMETRIC_UNLINK_FAILED: 'biometric_unlink_failed',
  TOKEN_REFRESHED: 'token_refreshed',
  ACCESS_DENIED: 'access_denied',
} as const;

export type AuthLoginMethod = 'code' | 'biometric' | 'anonymous';

export interface AuthLoginPayload {
  readonly method: AuthLoginMethod;
}

export interface AuthLoginFailedPayload extends AuthLoginPayload {
  readonly errorCode: string;
}
